export const processingFacilityFields = [
  {
    name: 'processingFacilityName',
    placeholder: 'Processing Facility Name',
    label: 'Processing Facility Name',
    disabled: true,
    size: 'small',
    select: true,
  },
  {
    name: 'processingFacilityAddress',
    placeholder: 'Processing Facility Address',
    label: 'Processing Facility Address',
    size: 'big',
    disabled: true,
    select: false,
  },
  {
    name: 'scope1',
    placeholder: 'Processing Facility Scope 1 (tonnes CO\u2082e)',
    label: 'Processing Facility Scope 1 (tonnes CO\u2082e)',
    size: 'small',
    select: false,
    disabled: true,
  },
  {
    name: 'scope2',
    placeholder: 'Processing Facility Scope 2 (tonnes CO\u2082e)',
    label: 'Processing Facility Scope 2 (tonnes CO\u2082e)',
    size: 'big',
    select: false,
    disabled: true,
  },
];

export const packageMaterialFields = [
  {
    name: 'packingMaterialName',
    placeholder: 'Enter packaging material name/origin',
    label: 'Enter packaging material name/origin',
    size: 'big',
    select: true,
    disabled: true,
    checkbox: false,
  },
  {
    name: 'packingSupplier',
    placeholder: 'Supplier',
    label: 'Supplier',
    size: 'big',
    select: true,
    disabled: false,
    checkbox: false,
  },
  {
    name: 'packingTemperatureControl',
    placeholder: 'Temperature control',
    label: 'Temperature control',
    size: 'big',
    select: true,
    disabled: false,
    checkbox: false,
  },
  {
    name: 'packingViaAir',
    placeholder: 'Check this box if transportation is via air',
    label: 'Check this box if transportation is via air',
    size: 'big',
    select: false,
    disabled: false,
    checkbox: true,
  },
];

export const initialValues = {
  ingredients: {
    ingredientName: undefined,
    ingredientOrigin: undefined,
    bestFitProductionRegion: undefined,
    ingredientQuantity: '',
    ingredientUnit: undefined,
  },

  packingMaterial: {
    packingMaterialName: undefined,
    packingMaterialOrigin: undefined,
    packingMaterialbestFitProductionRegion: undefined,
    packingMaterialQuantity: '',
    packingMaterialUnit: undefined,
    numberofUnitsPerPackingMaterial: '',
  },
};
